<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{ "bikeshop.modal.cancelation.cancel_package" | translate }}
    </h4>
    <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
    >
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-5">
            <div
                    class="col-md-5"
                    style="display: flex; flex-direction: column; justify-content: space-between"
            ></div>
            <div>
                <h5 class="modal-title" id="modal-basic-title">
                    {{ "bikeshop.modal.cancelation.are_you_sure_youre_done" | translate }}
                </h5>
                <br/>
                <ul style="padding-left: 20px">
                    <li>
                        {{
                        "bikeshop.modal.cancelation.cancellation_will_be_effective_immediately"
                            | translate
                        }}
                        <!-- Cancellation will be effective immediately. You will
                        only be billed for your current usage of the current billing period -->
                    </li>
                    <li>
                        {{ "bikeshop.modal.cancelation.come_back_anytime" | translate }}
                        <!-- Come back anytime. If you restart within 10 months, your profiles,
                        customers and setting will be waiting for you. -->
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div
                class="col-md-5"
                style="display: flex; flex-direction: column; justify-content: space-between"
        >
            <div>
                <h5 class="modal-title" id="modal-basic-title">
                    {{ "bikeshop.modal.cancelation.stick_around" | translate }}
                </h5>
                <br/>
                <ul style="padding-left: 20px">
                    <li>
                        <!-- We are constantly adding new features and working on feedback from
                        our customers. -->
                        {{ "bikeshop.modal.cancelation.adding_new_features" | translate }}
                    </li>
                    <li>
                        <!-- If you have any comments or specific reasons for leaving we would
                        love to hear about it: daniel@hubtiger.com -->
                        {{ "bikeshop.modal.cancelation.comments" | translate }}
                    </li>
                </ul>
            </div>
            <div>
                <button
                        pButton
                        type="button"
                        class="p-button-raised"
                        label="Cancel Plan"
                        (click)="cancelPackage()"
                ></button>
            </div>
        </div>
    </div>
</div>

<!-- [disabled]="buttonDisabled" -->
